import { ref, nextTick } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import FavouritesView from '@/views/FavouritesView.vue'
import SearchView from '@/views/SearchView.vue'
import BrowseView from '@/views/BrowseView.vue'
import CategoryContainerView from '@/views/CategoryContainerView.vue'
import CountryContainerView from '@/views/CountryContainerView.vue'
import Error404View from '@/views/Error404View.vue'

export const rootRoutePaths = ref<Record<string, string>>({})
export const scrollPositions: Record<string, number> = {}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'favourites',
      component: FavouritesView,
    },
    {
      path: '/search',
      name: 'search',
      component: SearchView,
    },
    {
      path: '/browse',
      name: 'browse',
      component: BrowseView,
      children: [
        {
          path: 'category',
          name: 'categoryContainer',
          component: CategoryContainerView,
          children: [
            {
              path: ':pathMatch(.*)*',
              name: 'category',
              component: CategoryContainerView,
              meta: {
                hideFromBreadcrumbs: true,
              },
            },
          ],
        },
        {
          path: 'country',
          name: 'countryContainer',
          component: CountryContainerView,
          children: [
            {
              path: ':pathMatch(.*)*',
              name: 'country',
              component: CountryContainerView,
              meta: {
                hideFromBreadcrumbs: true,
              },
            },
          ],
        },
      ],
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'error404',
      component: Error404View,
      meta: {
        hidden: true,
      },
    },
  ],
})

router.beforeEach((to, from, next) => {
  if (from.name) {
    // Store root route path
    const rootRouteName = String(from.matched[0].name)
    if (rootRouteName) {
      if (to.name === 'error404') {
        delete rootRoutePaths.value[rootRouteName]
      } else {
        rootRoutePaths.value[rootRouteName] = from.path
      }
    }

    // Store scroll position
    scrollPositions[String(from.name)] = window.scrollY
  }

  next()
})

router.afterEach(async (to) => {
  await nextTick()

  if (to.name) {
    // Restore scroll position
    window.scroll(0, scrollPositions[String(to.name)] || 0)

    // Update canonical meta
    document
      .querySelector('link[rel="canonical"]')
      ?.setAttribute('href', `https://viritin.fi${to.path}`)
  }
})

export default router
